import { SCREEN_TYPE } from "../../../utils/constants";

export const CT_ScreenEvntDtls = {
  R_STOCKS: {
    detailScreen: {
      screenName: "Stocks & Securities Servicing Detail Screen",
      screenType: SCREEN_TYPE.StockScreenType,
    },
    drawerScreen: {
      screenName: "Stocks & Securities Servicing Quick Actions Drawer Screen",
      screenType: SCREEN_TYPE.StockScreenType,
    },
    myDocuments: {
      screenName:
        "Stocks & Securities Servicing My Documents Option Select Screen",
      screenType: SCREEN_TYPE.StockScreenType,
    },
    account_statementDtl: {
      screenName:
        "Stocks & Securities Servicing Statment of Accounts Enter Details Screen",
      screenType: SCREEN_TYPE.StockScreenType,
    },
    accStmtDownloadSuccess: {
      screenName:
        "Stocks & Securities Servicing Statment of Accounts Download Successful Screen",
      screenType: SCREEN_TYPE.StockScreenType,
    },
    contractNoteDtl: {
      screenName:
        "Stocks & Securities Servicing Contract Note Enter Details Screen",
      screenType: SCREEN_TYPE.StockScreenType,
    },
    contractNoteDownSuccess: {
      screenName:
        "Stocks & Securities Servicing Contract Note Download Successful Screen",
      screenType: SCREEN_TYPE.StockScreenType,
    },
    captialGainDetail: {
      screenName:
        "Stocks & Securities Servicing Capital Gain Enter Details Screen",
      screenType: SCREEN_TYPE.StockScreenType,
    },
    captialGainDownloadSuccess: {
      screenName:
        "Stocks & Securities Servicing Capital Gain Download Successful Screen",
      screenType: SCREEN_TYPE.StockScreenType,
    },
    addManuallyEnterDetails: {
      screenName: "Servicing Add Product Manually Enter Details Drawer Screen",
      screenType: SCREEN_TYPE.StockScreenType,
    },
    addManualOtpScreen: {
      screenName: "Servicing Add Manually OTP Verify Drawer Screen",
      screenType: SCREEN_TYPE.StockScreenType,
    },
    addManualRelationshipScreen: {
      screenName:
        "Servicing Add Manually Realtionship With Holder Option Selection Screen",
      screenType: SCREEN_TYPE.StockScreenType,
    },
  },
  R_LIFE: {
    liDetails: {
      screenName: "Life Insurance Servicing Detail Screen",
      screenType: SCREEN_TYPE.LIScreenType,
    },
    liServiceDrawerScreen: {
      screenName: "Life Insurance Servicing Services Drawer Screen",
      SCREEN_TYPE: SCREEN_TYPE.LIScreenType,
    },
    liPaymentDrawerScreen: {
      screenName: "Life Insurance Servicing Payment Drawer Screen",
      SCREEN_TYPE: SCREEN_TYPE.LIScreenType,
    },
    liUpdateProfileDrawer: {
      screenName: "Life Insurance Servicing Update Profile Drawer Screen",
      SCREEN_TYPE: "li_servicing",
    },
    liPolicyServicesDrawer: {
      screenName: "Life Insurance Servicing Policy Services Drawer Screen",
      SCREEN_TYPE: "li_servicing",
    },
    liDownloadStmtDrawer: {
      screenName: "Life Insurance Servicing Download Statements Drawer Screen",
      SCREEN_TYPE: "li_servicing",
    },
    liTrackReqDrawer: {
      screenName: "Life Insurance Servicing Track Request Drawer Screen",
      SCREEN_TYPE: "li_servicing",
    },
    liPolicyBondSuccess: {
      screenName:
        "Life Insurance Servicing Policy Bond Download Success Screen",
      SCREEN_TYPE: "li_servicing",
    },
    liFeedback: {
      screenName: "Life Insurance Servicing Experience Feedback Enter Screen",
      SCREEN_TYPE: "li_servicing",
    },
    liPolicyBondFailure: {
      screenName:
        "Life Insurance Servicing Policy Bond Download Failure Screen",
      SCREEN_TYPE: "li_servicing",
    },
    liTaxCertDetail: {
      screenName:
        "Life Insurance Servicing Tax Certificate Enter Details Screen",
      SCREEN_TYPE: "li_servicing",
    },
    liDocDownloadSuccess: {
      screenName: "Life Insurance Servicing Document Download Success Screen",
      SCREEN_TYPE: "li_servicing",
    },
    liEmailSuccess: {
      screenName: "Life Insurance Servicing Email Sent Document Success Screen",
      SCREEN_TYPE: "li_servicing",
    },
    liEmailIdEnter: {
      screenName: "Life Insurance Servicing Email ID Enter Screen",
      SCREEN_TYPE: "li_servicing",
    },
    liEmailOtpVer: {
      screenName:
        "Life Insurance Servicing Email OTP Verification Enter Screen",
      SCREEN_TYPE: "li_servicing",
    },
    liEmailRegSuccess: {
      screenName: "Life Insurance Servicing Email Registered Success Screen",
      SCREEN_TYPE: "li_servicing",
    },
    liUpdateEmailSubmitReqSuccess: {
      screenName:
        "Life Insurance Servicing Update Email Submit Request Success Screen",
      SCREEN_TYPE: "li_servicing",
    },
    liWhatsappSentDocSuccess: {
      screenName:
        "Life Insurance Servicing Whatsapp Sent Document Success Screen",
      SCREEN_TYPE: "li_servicing",
    },
    liPolicyAccStmtDetail: {
      screenName:
        "Life Insurance Servicing Policy Account Statement Enter Details Screen",
      SCREEN_TYPE: "li_servicing",
    },
    liPremReceiptsDetail: {
      screenName:
        "Life Insurance Servicing Premium Receipts Enter Details Screen",
      SCREEN_TYPE: "li_servicing",
    },
    liApiFailureError: {
      screenName: "Life Insurance Servicing API Failure Error Screen",
      SCREEN_TYPE: "li_servicing",
    },
    liWhatsappOptInDetailDrawer: {
      screenName:
        "Life Insurance Servicing Whatsapp Opt In Enter Details Drawer Screen",
      SCREEN_TYPE: "li_servicing",
    },
    liWhatsappOptInSuccess: {
      screenName: "Life Insurance Servicing Whatsapp Opt In Success Screen",
      SCREEN_TYPE: "li_servicing",
    },
    liWhatsappOptOutDetailDrawer: {
      screenName:
        "Life Insurance Servicing Whatsapp Opt Out Enter Details Drawer Screen",
      SCREEN_TYPE: "li_servicing",
    },
    liWhatsappOptOutSelectDrawer: {
      screenName:
        "Life Insurance Servicing Whatsapp Opt Out Action Select Drawer Screen",
      SCREEN_TYPE: "li_servicing",
    },
    liWhatsappOptOutSuccess: {
      screenName: "Life Insurance Servicing Whatsapp Opt Out Success Screen",
      SCREEN_TYPE: "li_servicing",
    },
    liRegEmailDetailDrawer: {
      screenName:
        "Life Insurance Servicing Register Email ID Enter Details Drawer Screen",
      SCREEN_TYPE: "li_servicing",
    },
    liEmailIdDetailsDrawer: {
      screenName:
        "Life Insurance Servicing Update Email ID Enter Details Drawer Screen",
      SCREEN_TYPE: "li_servicing",
    },
    liUpdateMobileDetailsDrawer: {
      screenName:
        "Life Insurance Servicing Update Mobile Number Enter Details Drawer Screen",
      SCREEN_TYPE: "li_servicing",
    },
    liOtpVer: {
      screenName:
        "Life Insurance Servicing Mobile Number OTP Verification Enter Screen",
      SCREEN_TYPE: "li_servicing",
    },
    liUpdateMobileNumSuccess: {
      screenName:
        "Life Insurance Servicing Updated Mobile Number Success Screen",
      SCREEN_TYPE: "li_servicing",
    },
    liUpdateMobileReqSubmitSuccess: {
      screenName:
        "Life Insurance Servicing Update Mobile Number Submit Request Success Screen",
      SCREEN_TYPE: "li_servicing",
    },
    liMobileNumDetailDrawer: {
      screenName:
        "Life Insurance Servicing Register Mobile Number Enter Details Drawer Screen",
      SCREEN_TYPE: "li_servicing",
    },
    liUpdatePanDetail: {
      screenName:
        "Life Insurance Servicing Update PAN Enter Details Drawer Screen",
      SCREEN_TYPE: "li_servicing",
    },
    liPanAddressOtpVerEnter: {
      screenName:
        "Life Insurance Servicing PAN Address OTP Verification Enter Screen",
      SCREEN_TYPE: "li_servicing",
    },
    liUpdatePanSubmitSuccess: {
      screenName:
        "Life Insurance Servicing Update PAN Submit Request Success Screen",
      SCREEN_TYPE: "li_servicing",
    },
    liUpdateCommAddrDetail: {
      screenName:
        "Life Insurance Servicing Update Communication Address Enter Details Screen",
      SCREEN_TYPE: "li_servicing",
    },
    liCommAddrReqSuccess: {
      screenName:
        "Life Insurance Servicing Update Communication Address Request Success Screen",
      SCREEN_TYPE: "li_servicing",
    },
    liDocMedSelectDrawer: {
      screenName:
        "Life Insurance Servicing Document Upload Medium Select Drawer Screen",
      SCREEN_TYPE: "li_servicing",
    },
    liDocReviewDrawer: {
      screenName: "Life Insurance Servicing Document Review Drawer Screen",
      SCREEN_TYPE: "li_servicing",
    },
  },
  R_MF: {
    mfDetailScreen: {
      screenName: "Mutual Funds Servicing Detail Screen",
      SCREEN_TYPE: SCREEN_TYPE.MFScreenType,
    },
    mfQuickActDrawer: {
      screenName: "Mutual Funds Servicing Quick Actions Drawer Screen",
      SCREEN_TYPE: SCREEN_TYPE.MFScreenType,
    },
    mfTransactDrawer: {
      screenName: "Mutual Funds Servicing Transact Drawer Screen",
      SCREEN_TYPE: SCREEN_TYPE.MFScreenType,
    },
    mfMyStmtsDrawer: {
      screenName: "Mutual Funds Servicing My Statements Drawer Screen",
      SCREEN_TYPE: SCREEN_TYPE.MFScreenType,
    },
    mfCapitalGainStmtDetail: {
      screenName:
        "Mutual Funds Servicing Capital Gain Statement Enter Details Screen",
      SCREEN_TYPE: SCREEN_TYPE.MFScreenType,
    },
    mfAccStmtDetail: {
      screenName:
        "Mutual Funds Servicing Account Statement Enter Details Screen",
      SCREEN_TYPE: SCREEN_TYPE.MFScreenType,
    },
    mfDownloadFormatOptionSelect: {
      screenName:
        "Mutual Funds Servicing Select Download Format Option Select Screen",
      SCREEN_TYPE: SCREEN_TYPE.MFScreenType,
    },
    mfExitLoadStmtDetail: {
      screenName:
        "Mutual Funds Servicing Exit Load Statement Enter Details Screen",
      SCREEN_TYPE: SCREEN_TYPE.MFScreenType,
    },
  },
  R_HI: {
    hiDetail: {
      screenName: "Health Insurance Servicing Detail Screen",
      SCREEN_TYPE: SCREEN_TYPE.HIScreenType,
    },
    hiQuickActDrawer: {
      screenName: "Health Insurance Servicing Quick Actions Drawer Screen",
      SCREEN_TYPE: SCREEN_TYPE.HIScreenType,
    },
    hiUtilitiesDrawer: {
      screenName: "Health Insurance Servicing Utilities Drawer Screen",
      SCREEN_TYPE: SCREEN_TYPE.HIScreenType,
    },
    hiPolicyDocDrawer: {
      screenName: "Health Insurance Servicing Policy Documents Drawer Screen",
      SCREEN_TYPE: SCREEN_TYPE.HIScreenType,
    },
    hiDocDownloadSuccess: {
      screenName:
        "Health Insurance Servicing {{Document Name}} Download Success Drawer Screen",
      SCREEN_TYPE: SCREEN_TYPE.HIScreenType,
    },
    hiDocDownloadFailure: {
      screenName:
        "Health Insurance Servicing {{Document Name}} Download Failure Drawer Screen",
      SCREEN_TYPE: SCREEN_TYPE.HIScreenType,
    },
    hiMedicalReportDownload: {
      screenName:
        "Health Insurance Servicing Member Medical Reports Download Screen",
      SCREEN_TYPE: SCREEN_TYPE.HIScreenType,
    },
    hiEditPolicyDetails: {
      screenName: "Health Insurance Servicing Edit Policy Details Screen",
      SCREEN_TYPE: SCREEN_TYPE.HIScreenType,
    },
    hiPremiumChangeWarningDrawer: {
      screenName:
        "Health Insurance Servicing Premium Change Warning Drawer Screen",
      SCREEN_TYPE: SCREEN_TYPE.HIScreenType,
    },
    hiEditProposerNameDrawer: {
      screenName: "Health Insurance Servicing Edit Proposer Name Drawer Screen",
      SCREEN_TYPE: SCREEN_TYPE.HIScreenType,
    },
    hiSelIdentityProofDrawer: {
      screenName:
        "Health Insurance Servicing Select Identity Proof Drawer Screen",
      SCREEN_TYPE: SCREEN_TYPE.HIScreenType,
    },
    hiUploadIdentityProofDrawer: {
      screenName:
        "Health Insurance Servicing Upload Identity Proof Drawer Screen",
      SCREEN_TYPE: SCREEN_TYPE.HIScreenType,
    },
    hiEditProposerDOBDrawer: {
      screenName: "Health Insurance Servicing Edit Proposer DOB Drawer Screen",
      SCREEN_TYPE: SCREEN_TYPE.HIScreenType,
    },
    hiEditProposerNameReqSubSuccess: {
      screenName:
        "Health Insurance Servicing Proposer Name Change Request Submit Success Screen",
      SCREEN_TYPE: SCREEN_TYPE.HIScreenType,
    },
    hiProposerDOBChngReqSubSuccess: {
      screenName:
        "Health Insurance Servicing Proposer DOB Change Request Submit Success Screen",
      SCREEN_TYPE: SCREEN_TYPE.HIScreenType,
    },
    hiEditProposerGenderDrawer: {
      screenName:
        "Health Insurance Servicing Edit Proposer Gender Drawer Screen",
      SCREEN_TYPE: SCREEN_TYPE.HIScreenType,
    },
    hiGenderChangeReqSubSuccess: {
      screenName:
        "Health Insurance Servicing Proposer Gender Change Request Submit Success Screen",
      SCREEN_TYPE: SCREEN_TYPE.HIScreenType,
    },
    hiEditProposerPanDrawer: {
      screenName: "Health Insurance Servicing Edit Proposer PAN Drawer Screen",
      SCREEN_TYPE: SCREEN_TYPE.HIScreenType,
    },
    hiProposerPanChngReqSubSuccess: {
      screenName:
        "Health Insurance Servicing Proposer PAN Change Request Submit Success Screen",
      SCREEN_TYPE: SCREEN_TYPE.HIScreenType,
    },
    hiEditMobNumDrawer: {
      screenName: "Health Insurance Servicing Edit Mobile Number Drawer Screen",
      SCREEN_TYPE: SCREEN_TYPE.HIScreenType,
    },
    hiEnterOtpDrawer: {
      screenName: "Health Insurance Servicing Enter OTP Drawer Screen",
      SCREEN_TYPE: SCREEN_TYPE.HIScreenType,
    },
    hiMobNumChngSuccess: {
      screenName:
        "Health Insurance Servicing Mobile Number Change Success Screen",
      SCREEN_TYPE: SCREEN_TYPE.HIScreenType,
    },
    hiEditAltMobNumDrawer: {
      screenName:
        "Health Insurance Servicing Edit Alternate Mobile Number Drawer Screen",
      SCREEN_TYPE: SCREEN_TYPE.HIScreenType,
    },
    hiAltMobNumChngSuccess: {
      screenName:
        "Health Insurance Servicing Alternate Mobile Number Change Success Screen",
      SCREEN_TYPE: SCREEN_TYPE.HIScreenType,
    },
    hiChngEmailIdDrawer: {
      screenName: "Health Insurance Servicing Change Email ID Drawer Screen",
      SCREEN_TYPE: SCREEN_TYPE.HIScreenType,
    },
    hiEmailIdChngSuccess: {
      screenName: "Health Insurance Servicing Email ID Change Success Screen",
      SCREEN_TYPE: SCREEN_TYPE.HIScreenType,
    },
    hiEditAddrDrawer: {
      screenName: "Health Insurance Servicing Edit Address Drawer Screen",
      SCREEN_TYPE: SCREEN_TYPE.HIScreenType,
    },
    hiAddrChngReqSubSuccess: {
      screenName:
        "Health Insurance Servicing Address Change Request Submit Success Screen",
      SCREEN_TYPE: SCREEN_TYPE.HIScreenType,
    },
    hiEditNomineeDetailsDrawer: {
      screenName:
        "Health Insurance Servicing Edit Nominee Details Drawer Screen",
      SCREEN_TYPE: SCREEN_TYPE.HIScreenType,
    },
    hiSelReltnWidProposerDrawer: {
      screenName:
        "Health Insurance Servicing Select Relation With Proposer Drawer Screen",
      SCREEN_TYPE: SCREEN_TYPE.HIScreenType,
    },
    hiNomineeDetailsChngSuccess: {
      screenName:
        "Health Insurance Servicing Nominee Details Change Success Screen",
      SCREEN_TYPE: SCREEN_TYPE.HIScreenType,
    },
    hiCashlessNtwrkHospInCity: {
      screenName: "Cashless Network Hospitals in Your City Screen",
      SCREEN_TYPE: SCREEN_TYPE.HIScreenType,
    },
    hiCashlessNtwrkHospList: {
      screenName: "Cashless Network Hospitals List Screen",
      SCREEN_TYPE: SCREEN_TYPE.HIScreenType,
    },
    hiCashlessNtwrkHospMapView: {
      screenName: "Cashless Network Hospitals Map View Screen",
      SCREEN_TYPE: SCREEN_TYPE.HIScreenType,
    },
    hiCashlessNtwrkHospErr: {
      screenName: "Cashless Network Hospitals Error Screen",
      SCREEN_TYPE: SCREEN_TYPE.HIScreenType,
    },
  },
  R_GAE: {
    gaPerDetailsVer: {
      screenName: "Servicing Personal Details Verification Screen",
      SCREEN_TYPE: SCREEN_TYPE.PreLoginScreenType,
    },
    gaPerDetailsAuthWait: {
      screenName: "Servicing Personal Details Authentication Waiting Screen",
      SCREEN_TYPE: SCREEN_TYPE.PreLoginScreenType,
    },
    gaLoginMobNumDetails: {
      screenName: "Servicing Login Mobile Number Enter Details Screen",
      SCREEN_TYPE: SCREEN_TYPE.LoginScreenType,
    },
    gaLoginMobNumOtpVer: {
      screenName: "Servicing Login Mobile Number OTP Verification Screen",
      SCREEN_TYPE: SCREEN_TYPE.LoginScreenType,
    },
    gaLoginSetMpinDetails: {
      screenName:"Servicing Login Setup mPIN Details Enter Screen",
      SCREEN_TYPE: SCREEN_TYPE.LoginScreenType,
    },
    gaLoginSecureOptSelection: {
      screenName: "Servicing Login Securely Option Selection Screen",
      SCREEN_TYPE: SCREEN_TYPE.LoginScreenType,
    },
    gaPerDetailAuthSuccess: {
      screenName:
        "Servicing Personal Details Authentication Successful Screen",
        SCREEN_TYPE: SCREEN_TYPE.LoginScreenType,
    },
   gaPerDetailAuthFail: {
      screenName: "Servicing Personal Details Authentication Failed Screen",
      SCREEN_TYPE: SCREEN_TYPE.LoginScreenType,
    },
    gaHomescreen: {
      screenName:
        "Servicing Homescreen",
      SCREEN_TYPE: SCREEN_TYPE.DashboardScreenType,
    },
    gaUnableToNavError: {
      screenName: "Servicing Unable To Navigate Error Screen",
      SCREEN_TYPE: SCREEN_TYPE.DashboardScreenType,
    },
    gaSearchScreen: {
      screenName: "Servicing Search Screen",
      SCREEN_TYPE: SCREEN_TYPE.DashboardScreenType,
    },
    gaHambMenuDetail: {
      screenName: "Servicing Hamburger Menu Details Screen",
      SCREEN_TYPE: SCREEN_TYPE.DashboardScreenType,
    },
    gaMyProfileDetail: {
      screenName: "Servicing My Profile Details Screen",
      SCREEN_TYPE: SCREEN_TYPE.DashboardScreenType,
    },
    gaUtilitiesOptSelection: {
      screenName: "Servicing Utilities Option Selection Screen",
      SCREEN_TYPE: SCREEN_TYPE.DashboardScreenType,
    },
    gaBranchLocatorMain: {
      screenName: "Servicing Branch Locator Main Screen",
      SCREEN_TYPE: SCREEN_TYPE.DashboardScreenType,
    },  
    gaBranchLocaBranList: {
      screenName: "Servicing Branch Locator Branch List Screen",
      SCREEN_TYPE: SCREEN_TYPE.DashboardScreenType,
    },
    gaCashlessNetHospMain: {
      screenName:
        "Servicing Cashless Network Hospitals Main Screen",
        SCREEN_TYPE: SCREEN_TYPE.DashboardScreenType,
    },
    gaCashlessNetHospInCity: {
      screenName:
        "Servicing Cashless Network Hospitals in Your City Screen",
        SCREEN_TYPE: SCREEN_TYPE.DashboardScreenType,
    },
    gaCashlessNetHospList: {
      screenName:
        "Servicing Cashless Network Hospitals List Screen",
        SCREEN_TYPE: SCREEN_TYPE.DashboardScreenType,
    },
    gaCashlessNetHospMapView: {
      screenName:
        "Servicing Cashless Network Hospitals Map View Screen",
        SCREEN_TYPE: SCREEN_TYPE.DashboardScreenType,
    },
    gaCashlessNetHospError: {
      screenName:
        "Servicing Cashless Network Hospitals Error Screen",
        SCREEN_TYPE: SCREEN_TYPE.DashboardScreenType,
    },
    gaHelpSupportOptSelection: {
      screenName:
        "Servicing Help And Support Option Selection Screen",
        SCREEN_TYPE: SCREEN_TYPE.DashboardScreenType,
    },
    gaFaqMainCategSelection: {
      screenName:
        "Servicing Faq Main Category Selection Screen",
        SCREEN_TYPE: SCREEN_TYPE.DashboardScreenType,
    },
    gaFaqSubCategSelection: {
      screenName:
        "Servicing Faq Sub Category Selection Screen",
        SCREEN_TYPE: SCREEN_TYPE.DashboardScreenType,
    },
    gaFaqSubCategQueList: {
      screenName:
        "Servicing Faq Sub Category Questions List Screen",
        SCREEN_TYPE: SCREEN_TYPE.DashboardScreenType,
    },
    gaRaiseaBug: {
      screenName:
        "Servicing Raise A Bug Screen",
        SCREEN_TYPE: SCREEN_TYPE.DashboardScreenType,
    },
    gaConcernSubSuccess: {
      screenName:
        "Servicing Concern Submitted Successful Screen",
        SCREEN_TYPE: SCREEN_TYPE.DashboardScreenType,
    },
    gaRateUsRateScale: {
      screenName:
        "Servicing Rate Us Rating Scale Screen",
        SCREEN_TYPE: SCREEN_TYPE.DashboardScreenType,
    },
    gaRateUsWentWrongDetails: {
      screenName:
        "Servicing Rate Us What Went Wrong Detail Enter Screen",
        SCREEN_TYPE: SCREEN_TYPE.DashboardScreenType,
    },
    gaRateUsThankyou: {
      screenName:
        "Servicing Rate Us Thank You Screen",
        SCREEN_TYPE: SCREEN_TYPE.DashboardScreenType,
    },
    gaAppSettingOptSelection: {
      screenName:
        "Servicing App Settings Option Selection Screen",
        SCREEN_TYPE: SCREEN_TYPE.DashboardScreenType,
    },
    gaChangeMpinDetailsEnt: {
      screenName:
        "Servicing Change mPIN Detail Enter Screen",
        SCREEN_TYPE: SCREEN_TYPE.DashboardScreenType,
    },
    gaAppPermissionList: {
      screenName:
        "Servicing App Permissions list Screen",
        SCREEN_TYPE: SCREEN_TYPE.DashboardScreenType,
    },
    gaNotifiSettingsPerList: {
      screenName:
        "Servicing Notification Settings Permissions list Screen",
        SCREEN_TYPE: SCREEN_TYPE.DashboardScreenType,
    },
    gaPhoneSettingPerList: {
      screenName:
        "Servicing Phone Settings Permissions list Screen",
        SCREEN_TYPE: SCREEN_TYPE.DashboardScreenType,
    },
    gaRevokePerDrawer: {
      screenName:
        "Servicing Revoke Permissions Drawer Screen",
        SCREEN_TYPE: SCREEN_TYPE.DashboardScreenType,
    },
    gaDeviceAuthSettingsPerList: {
      screenName:
        "Servicing Device Authentication Settings Permissions list Screen",
        SCREEN_TYPE: SCREEN_TYPE.DashboardScreenType,
    },
    gaLogOutOptDrawer: {
      screenName:
        "Servicing Logout Options Drawer Screen",
        SCREEN_TYPE: SCREEN_TYPE.DashboardScreenType,
    },
    gaAddHoldingEnterDetailDrawer: {
      screenName:
        "Servicing Add Holdings Manually Enter Details Drawer Screen",
        SCREEN_TYPE: SCREEN_TYPE.DashboardScreenType,
    },
    gaAddProductEnterDetailDrawer: {
      screenName:
        "Servicing Add Product Manually Enter Details Drawer Screen",
        SCREEN_TYPE: SCREEN_TYPE.DashboardScreenType,
    },
    gaAddManualProdCategSelectDrawer: {
      screenName:
        "Servicing Add Manually Product Category Selection Drawer Screen",
        SCREEN_TYPE: SCREEN_TYPE.DashboardScreenType,
    },

    gaAddManualOTPVerDrawer: {
      screenName:
        "Servicing Add Manually OTP Verify Drawer Screen",
        SCREEN_TYPE: SCREEN_TYPE.DashboardScreenType,
    },
    gaAddManualEmailIDEntDetailDrawer: {
      screenName:
        "Servicing Add Manually Email ID Enter Details Drawer Screen",
        SCREEN_TYPE: SCREEN_TYPE.DashboardScreenType,
    },
    gaAddManualHolderDetailOptSelect: {
      screenName:
        "Servicing Add Manually Add Holder Details Option Selection Screen",
        SCREEN_TYPE: SCREEN_TYPE.DashboardScreenType,
    },
    gaAddManualHolAddSuccess: {
      screenName:
        "Servicing Add Manually Holder Added Successful Screen",
        SCREEN_TYPE: SCREEN_TYPE.DashboardScreenType,
    },
    gaAddManualRealtionHolOptSelect: {
      screenName:
        "Servicing Add Manually Realtionship With Holder Option Selection Screen",
        SCREEN_TYPE: SCREEN_TYPE.DashboardScreenType,
    },
    gaAddManualSelFolioNoDrawer: {
      screenName:
        "Servicing Add Manually Select Folio Number Drawer Screen",
        SCREEN_TYPE: SCREEN_TYPE.DashboardScreenType,
    },
    gaAddManualOtpVerifySuccess: {
      screenName:
        "Servicing Add Manually OTP Verify Successful Screen",
        SCREEN_TYPE: SCREEN_TYPE.DashboardScreenType,
    },
    gaAddManualCapitalGainStatDetail: {
      screenName:
        "Servicing Add Manually Capital Gain Statement Enter Details Screen",
        SCREEN_TYPE: SCREEN_TYPE.DashboardScreenType,
    },
    gaAddManualOtpVerifyFail: {
      screenName:
        "Servicing Add Manually OTP Verify Failure Screen",
        SCREEN_TYPE: SCREEN_TYPE.DashboardScreenType,
    }
  },
};
